// dashboard-frontend/src/components/AdminInquiries.jsx
import React, { useState, useEffect } from 'react';
import { fetchJSON } from '../api';

const AdminInquiries = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editingInquiryId, setEditingInquiryId] = useState(null);
  const [updateData, setUpdateData] = useState({ status: '', remark: '' });

  const fetchInquiries = async () => {
    try {
      const data = await fetchJSON('/api/inquiries');
      setInquiries(data);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchInquiries();
  }, []);

  const handleEditClick = (inquiry) => {
    setEditingInquiryId(inquiry._id);
    // Pre-fill with the current status; remark will be entered freshly
    setUpdateData({ status: inquiry.status, remark: '' });
  };

  const handleCancelEdit = () => {
    setEditingInquiryId(null);
    setUpdateData({ status: '', remark: '' });
  };

  const handleUpdateChange = (e) => {
    setUpdateData({ ...updateData, [e.target.name]: e.target.value });
  };

  const handleUpdateSubmit = async (inquiryId) => {
    try {
      const updated = await fetchJSON(`/api/inquiries/${inquiryId}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updateData),
      });
      // The response may be wrapped as { message, inquiry } or just the inquiry object
      const updatedInquiry = updated.inquiry || updated;
      setInquiries((prev) =>
        prev.map((inq) => (inq._id === inquiryId ? updatedInquiry : inq))
      );
      setEditingInquiryId(null);
      setUpdateData({ status: '', remark: '' });
    } catch (err) {
      alert('Error updating inquiry: ' + err.message);
    }
  };

  if (loading) return <p>Loading inquiries...</p>;
  if (error) return <p className="text-red-600">Error: {error}</p>;

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Inquiries</h2>
      {inquiries.length === 0 ? (
        <p>No inquiries found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border">
            <thead>
              <tr>
                <th className="py-2 px-4 border">Name</th>
                <th className="py-2 px-4 border">Email</th>
                <th className="py-2 px-4 border">Phone</th>
                <th className="py-2 px-4 border">Country</th>
                <th className="py-2 px-4 border">Comments</th>
                <th className="py-2 px-4 border">Source</th>
                <th className="py-2 px-4 border">Status</th>
                <th className="py-2 px-4 border">Assigned Admin</th>
                <th className="py-2 px-4 border">Remarks</th>
                <th className="py-2 px-4 border">Created At</th>
                <th className="py-2 px-4 border">Actions</th>
              </tr>
            </thead>
            <tbody>
              {inquiries.map((inq) => (
                <tr key={inq._id}>
                  <td className="py-2 px-4 border">{inq.name}</td>
                  <td className="py-2 px-4 border">{inq.email}</td>
                  <td className="py-2 px-4 border">{inq.phone}</td>
                  <td className="py-2 px-4 border">{inq.country || '-'}</td>
                  <td className="py-2 px-4 border">{inq.comments}</td>
                  <td className="py-2 px-4 border">{inq.source}</td>
                  <td className="py-2 px-4 border">
                    {editingInquiryId === inq._id ? (
                      <select
                        name="status"
                        value={updateData.status}
                        onChange={handleUpdateChange}
                        className="border p-1 rounded"
                      >
                        <option value="new">New</option>
                        <option value="in-progress">In Progress</option>
                        <option value="closed">Closed</option>
                      </select>
                    ) : (
                      inq.status
                    )}
                  </td>
                  <td className="py-2 px-4 border">
                    {inq.assignedAdmin ? inq.assignedAdmin.username : '-'}
                  </td>
                  <td className="py-2 px-4 border">
                    {editingInquiryId === inq._id ? (
                      <input
                        type="text"
                        name="remark"
                        value={updateData.remark}
                        onChange={handleUpdateChange}
                        placeholder="Add remark"
                        className="border p-1 rounded w-full"
                      />
                    ) : (
                      inq.adminRemarks && inq.adminRemarks.length > 0
                        ? inq.adminRemarks.map((r, idx) => (
                            <div key={idx}>
                              <strong>{r.admin && r.admin.username ? r.admin.username : 'Admin'}:</strong> {r.remark}
                            </div>
                          ))
                        : '-'
                    )}
                  </td>
                  <td className="py-2 px-4 border">
                    {new Date(inq.createdAt).toLocaleString()}
                  </td>
                  <td className="py-2 px-4 border">
                    {editingInquiryId === inq._id ? (
                      <>
                        <button
                          onClick={() => handleUpdateSubmit(inq._id)}
                          className="bg-green-500 text-white px-2 py-1 rounded mr-2"
                        >
                          Save
                        </button>
                        <button
                          onClick={handleCancelEdit}
                          className="bg-gray-500 text-white px-2 py-1 rounded"
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={() => handleEditClick(inq)}
                        className="bg-blue-500 text-white px-2 py-1 rounded"
                      >
                        Update
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminInquiries;
